import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, A11y } from 'swiper/modules';

export default {
	init() {
		var $sliders = $('.gallery-slider-inner.swiper');
		if (!$sliders.length) {
			return;
		}

		function updateAria(swiper) {
			var total = swiper.slides.length;
			swiper.slides.forEach(function (slide, index) {
				slide.setAttribute('aria-hidden', index !== swiper.activeIndex ? 'true' : 'false');
			});
			var $dots = $(swiper.pagination.el).find('.w-slider-dot');
			$dots.each(function (index) {
				var isActive = index === swiper.activeIndex;
				this.setAttribute('aria-pressed', isActive ? 'true' : 'false');
				this.setAttribute('tabindex', isActive ? '0' : '-1');
				this.setAttribute('aria-label', 'Show slide ' + (index + 1) + ' of ' + total);
			});
			var $ariaLabel = $(swiper.el).find('.w-slider-aria-label');
			if ($ariaLabel.length) {
				$ariaLabel.text('Slide ' + (swiper.activeIndex + 1) + ' of ' + total + '.');
			}
		}

		$sliders.each(function () {
			var $slider = $(this);
			if ($slider.data('swiper-initialized')) {
				return;
			}

			var $mask = $slider.find('.swiper-wrapper');
			if (!$mask.length) {
				return;
			}

			var autoplayEnabled = $slider.attr('data-autoplay') === 'true';
			var autoplayDelay = parseInt($slider.attr('data-delay'), 10);
			var speed = parseInt($slider.attr('data-duration'), 10);
			var infinite = $slider.attr('data-infinite') === 'true';
			var animation = $slider.attr('data-animation');
			var fade = animation === 'fade' || animation === 'cross';

			var $nav = $slider.find('.swiper-pagination');
			if ($nav.length) {
				$nav.empty();
			}

			var autoplayConfig = false;
			if (autoplayEnabled) {
				var resolvedDelay = Number.isFinite(autoplayDelay) ? autoplayDelay : 5000;
				autoplayConfig = {
					delay: resolvedDelay,
					disableOnInteraction: false,
				};
			}

			var swiper = new Swiper($slider[0], {
				modules: [Navigation, Pagination, Autoplay, EffectFade, A11y],
				slidesPerView: 1,
				slidesPerGroup: 1,
				loop: infinite,
				speed: Number.isFinite(speed) ? speed : 800,
				effect: fade ? 'fade' : 'slide',
				fadeEffect: { crossFade: true },
				autoplay: autoplayConfig,
				navigation: {
					prevEl: $slider.find('.swiper-button-prev')[0],
					nextEl: $slider.find('.swiper-button-next')[0],
				},
				pagination: {
					el: $nav[0],
					clickable: true,
					bulletClass: 'w-slider-dot',
					bulletActiveClass: 'w-active',
					renderBullet: function (index, className) {
						return (
							'<div class="' +
							className +
							'" data-wf-ignore role="button" tabindex="-1"></div>'
						);
					},
				},
				a11y: {
					enabled: true,
				},
				on: {
					init: function () {
						updateAria(this);
					},
					slideChange: function () {
						updateAria(this);
					},
				},
			});

			$slider.data('swiper-initialized', true);
			$slider.data('swiper', swiper);
		});
	},
};
